<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>BACS Processing Questionnaire</h1>
    <p>During your pre-engagement questionnaire you indicated that you have a requirement for us to process BACS payments on your behalf.</p>
    <p>Before beginning this questionnaire, you will need to request that your Service User Number (SUN) is linked to Qtac's Bureau Number - <strong>B20656</strong></p>
    <p>If you do not currently have a SUN, please contact your bank relationship manager to obtain one before proceeding.</p>
  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object,
  clientInvite: Object
})


const validateStep = () => {
  return true;
}



const executeStep = async () => {
  return true;
}


defineExpose({ validateStep, executeStep });

</script>